import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Grape, Download, Search, MoreVertical, CheckCircle2, XCircle, ChevronDown, User } from 'lucide-react';
import { Button } from './ui/Button';
export function MatchedResultPage() {
  const navigate = useNavigate();
  // Sample data based on the screenshot
  const rows = [{
    id: 1,
    bank: {
      date: '27/01/2024',
      desc: 'Salary',
      amount: '50,000'
    },
    status: 'matched',
    ledger: {
      date: '27/01/2024',
      desc: 'Salary',
      amount: '50,000'
    },
    matchScore: '90%'
  }, {
    id: 2,
    bank: {
      date: '27/01/2024',
      desc: 'Ajah Property',
      amount: '40,000'
    },
    status: 'matched',
    ledger: {
      date: '27/01/2024',
      desc: 'Ajah Property',
      amount: '40,000'
    },
    matchScore: '90%'
  }, {
    id: 3,
    bank: {
      date: '27/01/2024',
      desc: "Chichi's School fees",
      amount: '60,000'
    },
    status: 'unmatched',
    ledger: null,
    matchScore: null
  }, {
    id: 4,
    bank: {
      date: '27/01/2024',
      desc: 'Investment',
      amount: '40,000'
    },
    status: 'matched',
    ledger: {
      date: '27/01/2024',
      desc: 'Investment',
      amount: '40,000'
    },
    matchScore: '90%'
  }, {
    id: 5,
    bank: {
      date: '27/01/2024',
      desc: 'Piggy Savings',
      amount: '30,000'
    },
    status: 'unmatched',
    ledger: null,
    matchScore: null
  }, {
    id: 6,
    bank: {
      date: '27/01/2024',
      desc: 'Dorathy Loan',
      amount: '50,000'
    },
    status: 'matched',
    ledger: {
      date: '27/01/2024',
      desc: 'Dorathy Loan',
      amount: '50,000'
    },
    matchScore: '90%'
  }, {
    id: 7,
    bank: null,
    status: 'unmatched',
    ledger: {
      date: '27/01/2024',
      desc: 'Land part payment',
      amount: '75,000'
    },
    matchScore: null
  }, {
    id: 8,
    bank: {
      date: '27/01/2024',
      desc: 'Birthday party',
      amount: '130,000'
    },
    status: 'matched',
    ledger: {
      date: '27/01/2024',
      desc: 'Birthday party',
      amount: '130,000'
    },
    matchScore: '90%'
  }];
  return <div className="min-h-screen bg-white font-sans text-gray-900" data-id="element-190">
      {/* Header */}
      <header className="bg-white border-b border-gray-200 sticky top-0 z-20" data-id="element-191">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex justify-between items-center" data-id="element-192">
          <div className="flex items-center cursor-pointer" onClick={() => navigate('/reconcile')} data-id="element-193">

            <div className="bg-violet-100 p-2 rounded-lg mr-2" data-id="element-194">
              <Grape className="h-6 w-6 text-violet-600" data-id="element-195" />
            </div>
            <span className="text-xl font-bold text-gray-900 tracking-tight" data-id="element-196">
              Berry Finance
            </span>
          </div>

          <div className="flex items-center gap-3" data-id="element-197">
            <div className="flex items-center gap-2 cursor-pointer hover:bg-gray-50 p-2 rounded-lg transition-colors" data-id="element-198">
              <div className="w-10 h-10 bg-gray-200 rounded-full overflow-hidden border border-gray-200" data-id="element-199">
                <User className="w-full h-full p-2 text-gray-500" data-id="element-200" />
              </div>
              <ChevronDown className="h-4 w-4 text-gray-500" data-id="element-201" />
            </div>
          </div>
        </div>
      </header>

      <main className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-202">
        {/* Page Title & Actions */}
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-8" data-id="element-203">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-204">Matched Result</h1>
          <Button variant="outline" className="gap-2" onClick={() => navigate('/report')} data-id="element-205">

            <Download className="h-4 w-4" data-id="element-206" />
            Export
          </Button>
        </div>

        {/* Table Container */}
        <div className="border border-gray-200 rounded-lg overflow-hidden bg-white shadow-sm" data-id="element-207">
          {/* Table Headers */}
          <div className="grid grid-cols-12 bg-gray-50 border-b border-gray-200 text-xs font-semibold text-gray-500 uppercase tracking-wider" data-id="element-208">
            {/* Bank Header */}
            <div className="col-span-5 border-r border-gray-200" data-id="element-209">
              <div className="px-6 py-4 border-b border-gray-200 font-bold text-gray-900 text-sm normal-case" data-id="element-210">
                Bank Statement
              </div>
              <div className="grid grid-cols-12 px-6 py-3" data-id="element-211">
                <div className="col-span-3" data-id="element-212">Date</div>
                <div className="col-span-5" data-id="element-213">Description</div>
                <div className="col-span-3" data-id="element-214">Amount</div>
                <div className="col-span-1 text-right" data-id="element-215">Action</div>
              </div>
            </div>

            {/* Status Header */}
            <div className="col-span-2 border-r border-gray-200 px-4 py-3 flex items-end pb-3" data-id="element-216">
              Status
            </div>

            {/* Ledger Header */}
            <div className="col-span-5" data-id="element-217">
              <div className="px-6 py-4 border-b border-gray-200 font-bold text-gray-900 text-sm normal-case" data-id="element-218">
                Company Ledger
              </div>
              <div className="grid grid-cols-12 px-6 py-3" data-id="element-219">
                <div className="col-span-3" data-id="element-220">Date</div>
                <div className="col-span-5" data-id="element-221">Description</div>
                <div className="col-span-3" data-id="element-222">Amount</div>
                <div className="col-span-1 text-right" data-id="element-223">Action</div>
              </div>
            </div>
          </div>

          {/* Table Body */}
          <div className="divide-y divide-gray-100" data-id="element-224">
            {rows.map((row, index) => <div key={row.id} className={`grid grid-cols-12 items-stretch group ${index % 2 === 0 ? 'bg-orange-50/20' : 'bg-white'} ${row.status === 'unmatched' ? 'bg-red-50/40' : ''}`} data-id="element-225">

                {/* Bank Side */}
                <div className="col-span-5 border-r border-gray-100 p-0 flex flex-col justify-center" data-id="element-226">
                  {row.bank ? <div className="grid grid-cols-12 px-6 py-4 items-center" data-id="element-227">
                      <div className="col-span-3 text-sm text-gray-600" data-id="element-228">
                        {row.bank.date}
                      </div>
                      <div className="col-span-5 text-sm font-medium text-gray-900" data-id="element-229">
                        {row.bank.desc}
                      </div>
                      <div className="col-span-3 text-sm text-gray-600" data-id="element-230">
                        {row.bank.amount}
                      </div>
                      <div className="col-span-1 text-right" data-id="element-231">
                        <button className="text-gray-400 hover:text-gray-600" data-id="element-232">
                          <MoreVertical className="h-4 w-4" data-id="element-233" />
                        </button>
                      </div>
                    </div> : <div className="px-6 py-3" data-id="element-234">
                      <div className="relative" data-id="element-235">
                        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" data-id="element-236" />
                        <input type="text" placeholder="Find possible Match" className="w-full pl-9 pr-4 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-violet-500 italic bg-white" data-id="element-237" />

                      </div>
                    </div>}
                </div>

                {/* Status Column */}
                <div className="col-span-2 border-r border-gray-100 px-2 py-4 flex items-center justify-center" data-id="element-238">
                  {row.status === 'matched' ? <div className="flex items-center gap-1.5 text-emerald-600 font-bold text-xs" data-id="element-239">
                      <span data-id="element-240">{row.matchScore} Matched</span>
                      <CheckCircle2 className="h-4 w-4 fill-emerald-600 text-white" data-id="element-241" />
                    </div> : <div className="flex items-center gap-1.5 text-red-500 font-bold text-xs" data-id="element-242">
                      <span data-id="element-243">Unmatched</span>
                      <XCircle className="h-4 w-4 fill-red-500 text-white" data-id="element-244" />
                    </div>}
                </div>

                {/* Ledger Side */}
                <div className="col-span-5 p-0 flex flex-col justify-center" data-id="element-245">
                  {row.ledger ? <div className="grid grid-cols-12 px-6 py-4 items-center" data-id="element-246">
                      <div className="col-span-3 text-sm text-gray-600" data-id="element-247">
                        {row.ledger.date}
                      </div>
                      <div className="col-span-5 text-sm font-medium text-gray-900" data-id="element-248">
                        {row.ledger.desc}
                      </div>
                      <div className="col-span-3 text-sm text-gray-600" data-id="element-249">
                        {row.ledger.amount}
                      </div>
                      <div className="col-span-1 text-right" data-id="element-250">
                        <button className="text-gray-400 hover:text-gray-600" data-id="element-251">
                          <MoreVertical className="h-4 w-4" data-id="element-252" />
                        </button>
                      </div>
                    </div> : <div className="px-6 py-3" data-id="element-253">
                      <div className="relative" data-id="element-254">
                        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" data-id="element-255" />
                        <input type="text" placeholder="Find possible Match" className="w-full pl-9 pr-4 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-violet-500 italic bg-white" data-id="element-256" />

                      </div>
                    </div>}
                </div>
              </div>)}

            {/* Special 1-to-Many Row (Car installment) */}
            <div className="grid grid-cols-12 items-stretch bg-emerald-50/10" data-id="element-257">
              {/* Left Side (Spanning) */}
              <div className="col-span-5 border-r border-gray-100 flex flex-col justify-center relative" data-id="element-258">
                <div className="grid grid-cols-12 px-6 py-4 items-center h-full" data-id="element-259">
                  <div className="col-span-3 text-sm text-gray-600" data-id="element-260">
                    27/01/2024
                  </div>
                  <div className="col-span-5 text-sm font-medium text-gray-900" data-id="element-261">
                    Car installment
                  </div>
                  <div className="col-span-3 text-sm text-gray-600" data-id="element-262">60,000</div>
                  <div className="col-span-1 text-right" data-id="element-263">
                    <button className="text-gray-400 hover:text-gray-600" data-id="element-264">
                      <MoreVertical className="h-4 w-4" data-id="element-265" />
                    </button>
                  </div>
                </div>
              </div>

              {/* Status Column (Stacked) */}
              <div className="col-span-2 border-r border-gray-100 flex flex-col" data-id="element-266">
                <div className="flex-1 flex items-center justify-center border-b border-gray-100 py-4" data-id="element-267">
                  <div className="flex items-center gap-1.5 text-emerald-600 font-bold text-xs" data-id="element-268">
                    <span data-id="element-269">90% Matched</span>
                    <CheckCircle2 className="h-4 w-4 fill-emerald-600 text-white" data-id="element-270" />
                  </div>
                </div>
                <div className="flex-1 flex items-center justify-center py-4" data-id="element-271">
                  <div className="flex items-center gap-1.5 text-emerald-600 font-bold text-xs" data-id="element-272">
                    <span data-id="element-273">90% Matched</span>
                    <CheckCircle2 className="h-4 w-4 fill-emerald-600 text-white" data-id="element-274" />
                  </div>
                </div>
              </div>

              {/* Right Side (Stacked Rows) */}
              <div className="col-span-5 flex flex-col" data-id="element-275">
                {/* Sub-row 1 */}
                <div className="grid grid-cols-12 px-6 py-4 items-center border-b border-gray-100" data-id="element-276">
                  <div className="col-span-3 text-sm text-gray-600" data-id="element-277">
                    27/01/2024
                  </div>
                  <div className="col-span-5 text-sm font-medium text-gray-900" data-id="element-278">
                    Car installment
                  </div>
                  <div className="col-span-3 text-sm text-gray-600" data-id="element-279">30,000</div>
                  <div className="col-span-1 text-right" data-id="element-280">
                    <button className="text-gray-400 hover:text-gray-600" data-id="element-281">
                      <MoreVertical className="h-4 w-4" data-id="element-282" />
                    </button>
                  </div>
                </div>
                {/* Sub-row 2 */}
                <div className="grid grid-cols-12 px-6 py-4 items-center" data-id="element-283">
                  <div className="col-span-3 text-sm text-gray-600" data-id="element-284">
                    27/01/2024
                  </div>
                  <div className="col-span-5 text-sm font-medium text-gray-900" data-id="element-285">
                    Car installment
                  </div>
                  <div className="col-span-3 text-sm text-gray-600" data-id="element-286">30,000</div>
                  <div className="col-span-1 text-right" data-id="element-287">
                    <button className="text-gray-400 hover:text-gray-600" data-id="element-288">
                      <MoreVertical className="h-4 w-4" data-id="element-289" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Pagination Footer */}
          <div className="bg-white border-t border-gray-200 px-6 py-4 flex items-center justify-between" data-id="element-290">
            <div className="flex items-center gap-4" data-id="element-291">
              <div className="flex items-center gap-2 text-sm text-gray-600" data-id="element-292">
                <span data-id="element-293">Rows per page</span>
                <div className="flex items-center gap-1 px-2 py-1 border border-gray-300 rounded-md cursor-pointer hover:bg-gray-50" data-id="element-294">
                  <span className="font-medium" data-id="element-295">10</span>
                  <ChevronDown className="h-3 w-3" data-id="element-296" />
                </div>
              </div>
              <span className="text-sm text-gray-600" data-id="element-297">1-10 of 40 rows</span>
            </div>

            <div className="flex items-center gap-2" data-id="element-298">
              <Button variant="outline" size="sm" className="h-8 px-3 text-gray-600" data-id="element-299">

                Previous
              </Button>
              <Button variant="outline" size="sm" className="h-8 px-3 text-gray-600" data-id="element-300">

                Next
              </Button>
            </div>
          </div>
        </div>
      </main>
    </div>;
}